<template>
  <div class="footer">
    <div class="html-container" v-html="sanitizedFooter"></div>
  </div>
</template>

<script setup lang="ts">
import type { Footer } from '../types/configuration/Footer'
import { t } from '../composables/Translation'
import { useSanitizeHtml } from '../composables/SanitizeHtml'
import { computed } from 'vue'

const { sanitizeHtml } = useSanitizeHtml()
const sanitizedFooter = computed(() => sanitizeHtml(t('footer.text')))

defineProps<{
  model: Footer | undefined
}>()
</script>

<style scoped lang="scss">
.footer {
  background-color: var(--background-color);
  display: flex;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 24px;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;

  color: var(--light-color);
  font-size: 12px;
  font-weight: 500;
}

::v-deep(.html-container a) {
  color: var(--text-color);
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
</style>
